export default "__VITE_ASSET__CX6lFb0Z__"